import React, { useState } from 'react';
import './libro_bl_more.css';
import {Libro_azul} from '../../Home/home_cinco/libro_azul/Libro_azul';
import Libro_bl_gri from '../../Home/home_cinco/libro_bl_grid/Libro_bl_gri';
import Libro_Verde from '../../Home/home_cinco/libro/Libro';
import { useTranslation } from 'react-i18next';
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Dot from '../../../assets/imgs/home_dos/dots.png'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

function libro_bl_more() {

    const [t] = useTranslation("home");
    const [activeIndex, setActiveIndex] = useState(0); 
    const [swiper, setSwiper] = useState(null);

    const handlePaginationClick = (index) => {
      swiper.slideTo(index)
    };

    const getActiveStyles = (boookId) => {
      if (boookId !== activeIndex) return {
        borderBottom: "3px solid transparent"
      };
      let color = "";
      switch (boookId) {
        case 0:
          color = "#9ABE67"
          break;

        case 1:
          color = "#D9D9D9"
          break;
      
        default:
          break;
      }
      return {
        borderBottom: `3px solid ${color}`
      }
    }

    return (
    <div className='home_cinco_v more_azul_lb more_azul_libro_blanco'>
      
      <div className='squareMiddleLeft'>
          <img src={Dot} alt='Imagen de cuadro con puntos'/>
      </div>

      <div className='swuareBottomRight'>
          <img src={Dot} alt='Imagen de cuadro con puntos'/>
      </div>
      <div className='homeContainer'>
        <div className="row1 h5_libros">
          <Swiper modules={[Navigation, Pagination, Scrollbar, A11y]}
            slidesPerView={1}
            pagination={{
              el: '.swiper-pagination-custom',
              clickable: 'true',
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.activeIndex)
            }}
            onSwiper={(swiper) => {setSwiper(swiper)}}
            a11y={true}
            loop={false}>
              <SwiperSlide ><Libro_Verde></Libro_Verde></SwiperSlide>
              <SwiperSlide ><Libro_azul></Libro_azul></SwiperSlide>
          </Swiper>
        </div>
        <div className="row2 ideasescr">
          <div className='col21 div-linea'
            onClick={() => handlePaginationClick(0)}>
              <div className='textContainerBook'>
                <p className="ideas" style={getActiveStyles(0)}>{(t('books.green'))}</p>
              </div>
            <div className="verde  "></div>
          </div>
          <div className='col23 div-linea'
            onClick={() => handlePaginationClick(1)}>
              <div className='textContainerBook'>
                <p className="ideas" style={getActiveStyles(1)}>{(t('books.blue'))}</p>
              </div>
            <div className="azul"></div>
          </div>
        </div>
        {/* <div className='swiper-pagination-custom row2 ideasescr'></div> */}

        <div className="row2 movil">
          <div className={'col21 div-linea'}
            onClick={() => handlePaginationClick(0)}>
            <p className="ideas">{(t('books.extra-mobile'))}<br/> {(t('books.green-mobile'))}</p>
            <div className="verde"></div>
          </div>
          <div className={'col22 div-linea'}
            onClick={() => handlePaginationClick(1)}>
            <p className="ideas">{(t('books.extra-mobile'))}<br/> {(t('books.blue-mobile'))}</p>
            <div className="azul"></div>
          </div>
        </div>
      </div>
    </div>
    );
}

export default libro_bl_more;